<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="subjects"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :clearable="isClearable"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="subjectTypesStatePublic.loading"
          :style="{ opacity: subjectTypesStatePublic.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay destinos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'ListSubjectTypesPublicCompany',
  data() {
    return {
      subjects: [],
      externDataForms: [
        'input-doc-form',
        'interno',
        'externo',
        'draftTray'
      ]
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', ['subjectTypesStatePublic']),
    optionSelected() {
      return this.subjectTypesStatePublic.list.find((option) => option.value === this.value);
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    isDisabled() {
      return this.disabled
        || !this.subjectTypesStatePublic.list.length
        || this.subjectTypesStatePublic.loading;
    },
    hideOptions() {
      const formType = this.$route.path.split('/');
      return this.externDataForms.includes(formType[formType.length - 1]);
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.subjectTypesStatePublic.list.find((option) => option.value === this.value);
    }
  },
  created() {
    const { wizard } = this.$route.params;
    const internSubjects = ['usuarios', 'unidades', 'oficinas', 'direcciones', 'gerencias'];
    if (wizard && (wizard.includes('interno') || wizard.includes('externo'))) {
      this.subjects = this.subjectTypesStatePublic.list
        .map((subject) => {
          const typeSubject = subject;
          if (subject.value === 'usuarios') {
            return {
              ...typeSubject,
              label: 'Usuarios'
            };
          }
          return subject;
        })
        .filter((subject) => internSubjects.includes(subject.value))
        .filter((subject) => subject.value !== 'comisiones'
          && subject.value !== 'sanitarias' && subject.value !== 'oficinas'
          && subject.value !== 'unidades');
      console.log('ERQ', this.subjects);
    } else if (this.hideOptions) {
      this.subjects = this.subjectTypesStatePublic.list
        .filter((subject) => !subject.value
          .match(/docDigital|ministerios|personas|empresas|personasJuridicas|organismoEstado/i));
      console.log('ERQ 2', this.subjects);
    } else {
      if (!this.isSiss) {
        this.subjects = this.subjectTypesStatePublic.list
          .filter((subject) => subject.value !== 'comisiones' && subject.value !== 'sanitarias'
            && subject.value !== 'oficinas'
            && subject.value !== 'unidades');
        return;
      }
      this.subjects = this.subjectTypesStatePublic.list
        .filter((subject) => subject.value !== 'comisiones');
      console.log('ERQ 3', this.subjects);
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Destino' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true }
  }
};

</script>
